import { getPguri } from 'Utils/TrackingUtility'
import { isAlgoliaPage, getUrlParameter } from 'Utils/Utility'
import PrdDisplay from './PrdDisplay'

class Datalayer {
	constructor() {
		this.seoPageTemplateValue = document.body.dataset.seoPageTemplate
		this._listDisplayMode = this._listDisplayMode.bind(this)

		if (!window.tc_vars) {
			window.tc_vars = {}
		}
	}

	get REGEX() {
		return /^[^_]*_/
	}

	get pageType() {
		return isAlgoliaPage() ? 'algoliaPage' : window.tc_vars?.nav_GAsection
	}

	_isPlp() {
		return this.pageType === 'searchresult'
	}

	_isCart() {
		return this.pageType === 'cart'
	}

	_isHome() {
		return this.pageType === 'home'
	}

	_isConfirmation() {
		return this.pageType === 'confirmation'
	}

	defineDataLayerFilter(pageInstance) {
		yTos.configuration.dataLayerFilter = () => {
			this._pguri()
			this._msnCgGroup()
			this._rcmsCgGroup()
			this._emerchCgGroup()
			this._listDisplayMode()
			this._listName()
			this._prdPersonalized()
			this._prdPersonalizable()
			this._prdDisplay()
			this.bindEvents()
			this._sfmc_id()
			new PrdDisplay()
			this.overrideDataFromPage(pageInstance)

			yTos.notify('CAR::Datalayer::DataLayerFilterCalled')
		}
	}

	/**
	 * Retrieve the data from the page and overwrite the datalayer.
	 * This function needs the property dataLayer exposed by the instance of the page.
	 * @param {Object} pageInstance
	 */
	overrideDataFromPage(pageInstance) {
		if (pageInstance?.dataLayer) {
			const pageDataLayer = pageInstance.dataLayer

			Object.keys(pageDataLayer).forEach((key) => {
				if (pageDataLayer[key] === undefined) {
					delete pageDataLayer[key]
				}
			})

			window.tc_vars = {
				...window.tc_vars,
				...pageDataLayer,
			}
		}
	}

	bindEvents() {
		yTos.watch(
			{
				'CAR::SwitchGridFeed::Change': this._listDisplayMode,
			},
			{ scope: 'search' }
		)
	}

	_pguri() {
		window.tc_vars.pguri = getPguri()
	}

	_msnCgGroup() {
		let msncgGroup
		switch (this.seoPageTemplateValue) {
			case 'Instant search pages':
				msncgGroup = 'Search pages'
				break
			case 'Product pages':
				msncgGroup = 'Product page'
				break
			default:
				msncgGroup = this.seoPageTemplateValue
				break
		}

		window.tc_vars.msn_cgGroup = msncgGroup
	}

	_rcmsCgGroup() {
		window.tc_vars.rcms_cgGroup =
			this.seoPageTemplateValue === 'Instant search pages'
				? 'Search pages'
				: this.seoPageTemplateValue
	}

	_emerchCgGroup() {
		const { product_eng_category, product_eng_collection, nav_section_dept } = window.tc_vars

		const regex = this.REGEX
		const navSection = nav_section_dept.replace(regex, '')

		switch (this.pageType) {
			case 'item':
				window.tc_vars.emerch_cgGroup = `Product Details Page - ${product_eng_collection} ${product_eng_category}`
				break
			case 'searchresult':
				window.tc_vars.emerch_cgGroup =
					this.seoPageTemplateValue === 'Instant search pages'
						? 'Search pages'
						: `${this.seoPageTemplateValue} ${navSection}`
				break
			default:
				window.tc_vars.emerch_cgGroup = `${this.seoPageTemplateValue}`
				break
		}
	}

	_listName() {
		const { pguri } = window.tc_vars

		if (
			this.seoPageTemplateValue === 'Categories or collections listing pages' ||
			this.seoPageTemplateValue === 'Product listing pages'
		)
			window.tc_vars.listname = `${this.seoPageTemplateValue}: Product listing - ${pguri}`
	}

	_listDisplayMode(type = 'grid') {
		if (this._isPlp()) {
			window.tc_vars.listdisplaymode = type
		}
	}

	_prdPersonalized() {
		const { prdadjusted, prdengraved, prdembossed } = window.tc_vars

		window.tc_vars.prdpersonalized = 'No'

		if (prdadjusted || prdengraved || prdembossed) {
			window.tc_vars.prdpersonalized = 'Yes'
		}
	}

	_prdPersonalizable() {
		const { prdadjustable, prdengravable, prdembossable } = window.tc_vars

		window.tc_vars.prdpersonalizable = 'No'

		if (prdadjustable || prdengravable || prdembossable) {
			window.tc_vars.prdpersonalizable = 'Yes'
		}
	}

	_prdDisplay() {
		window.tc_vars.prddisplay = this.seoPageTemplateValue
	}

	_sfmc_id() {
		const sfmc_id = getUrlParameter('sfmc_id')
		window.tc_vars.sfmc_id = sfmc_id
	}
}

export default Datalayer
